import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


const DownloadMobileNumber = () => {
  const [rowData, setRowData] = useState([]);
  const [exportIds, setExportIds] = useState([]);
  const gridRef = useRef(null);

  useEffect(() => {
    fetchData();
  }, []);


  
                useEffect(() => {
                document.title = 'Download Mobile Number - Calendar Services';
             }, []);
    
  




  // Fetch data from the backend
  const fetchData = async () => {
    try {
      const response = await axios.post("https://calendarservicesapi.nithra.mobi/api/registrations", {
        isExport: 0, // Fetch only unexported data
      });
      setRowData(response.data);
      setExportIds(response.data.map((item) => item.id));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Handle export functionality
  const exportTableToCSV = async (filename) => {
    if (window.confirm("Are you sure to export data?")) {
      const ids = exportIds.join(",");

      try {
        // Update the export status on the backend
        await axios.post("https://calendarservicesapi.nithra.mobi/api/update", { update_id: ids });

        // Export the grid data to CSV
        gridRef.current.api.exportDataAsCsv({
          fileName: filename,
          columnSeparator: ",",
          skipHeader: false,
        });

        // Redirect to another page if needed
        window.location.href = "/download_mobile_number";
      } catch (error) {
        console.error("Error during export:", error);
      }
    }
  };

  const columnDefs = [
    { headerName: "SlNo", valueGetter: "node.rowIndex + 1", width: 100 },
    { headerName: "Name", field: "name", width: 200 },
    { headerName: "Type", field: "type", width: 150 },
    { headerName: "Mobile No", field: "mobileno", width: 200 },
  ];

  return (
    <div className="max-w-6xl mx-auto mt-8 bg-white">
      <h2  className="text-2xl font-bold mb-6 text-center" style={{ textAlign: "center" }}>
        Mobile Number
      </h2>
      <div className="table-responsive" style={{ marginBottom: "50px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
  <div></div> {/* This is a placeholder for table alignment */}
  <button
    className="bg-green-500 text-white px-4 py-2 rounded-md"
    onClick={() => exportTableToCSV("tamil_calender_mobile_number.csv")}
  >
    Export to Excel
  </button>
</div>

      <div
        className="ag-theme-alpine"
        style={{ height: "550", width: "65%", margin: "auto" }}
      >
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          columnDefs={columnDefs}
          domLayout="autoHeight"
          pagination={true}
          paginationPageSize={10}
          defaultColDef={{
            sortable: true,
            resizable: true,
          }}
        />
      </div>
    </div>
  );
};

export default DownloadMobileNumber;
